import { Attachment } from './Attachment'
import { HomeIssue } from './HomeIssue'
import { AccessInstruction } from './Homes'
import { Key } from './Key'

export interface HomeQualityCheckList {
  home: HomeQualityCheckHome
  id: number
  notes?: string
  precedingReservationId: number
  precedingReservationMoveOutDate?: string
  status: HomeQualityCheckStatus
  upcomingReservationId?: number
  upcomingReservationMoveInDate?: string
}

export interface HomeQualityCheckHome {
  id: number
  searchDocument: string
}

export interface HomeQualityCheckSummary {
  attachments?: Attachment[]
  home: HomeQualityCheckHome
  id: number
  notes?: string
  precedingReservationId: number
  precedingReservationMoveOutDate?: string
  status: HomeQualityCheckStatus
  upcomingReservationId?: number
  upcomingReservationMoveInDate?: string
}

export interface HomeQualityCheck {
  createdAt?: string
  home: HomeQualityCheckHome
  homeIssues?: HomeIssue[]
  hostCleaningRating: number
  id: number
  inspectionTasks?: HomeQualityCheckInspectionTask[]
  inspections?: HomeQualityCheckInspectionSummary[]
  notes?: string
  precedingReservation: HomeQualityCheckReservation
  status: HomeQualityCheckStatus
  turnoverCleaningJob?: {
    host?: {
      fullName: string
    }
    id: number
    jobTemplate: {
      name: string
    }
    scheduleDate: string
  }
  upcomingReservation?: HomeQualityCheckReservation
}

export interface HomeQualityCheckHome {
  accessInstructions?: AccessInstruction[]
  keys?: Key[]
}

export interface HomeQualityCheckReservation {
  hostDoorAccessCode?: string
  id: number
  includeDamageWaiverFee?: boolean
  intercomCode?: string
  lockboxBackupCode?: string
  lockboxCode?: string
  memberDoorAccessCode?: string
}

export interface HomeQualityCheckInspectionSummary {
  homeLocation: string
  status: HomeQualityCheckInspectionStatus
  total: number
  totalCompleted: number
}

export interface HomeQualityCheckInspectionTask {
  completedAt?: string
  homeIssue?: {
    notes?: string
    resolvedAt?: string
  }
  homeIssueId?: number
  homeQualityCheckInspectionTaskTemplate: HomeQualityCheckInspectionTaskTemplate
  id: number
  response?: string
}

export interface HomeQualityCheckInspectionTaskTemplate {
  homeInventoryItem: string
  homeLocation: string
  homeQualityCheckInspectionType: string
  inspectionTaskType: string
  prompt?: string
  promptHomeIssue: boolean
  taskOrder: number
}

export enum HomeQualityCheckInspectionStatus {
  COMPLETED = 'Completed',
  PENDING = 'Pending',
  STARTED = 'Started',
}

export enum HomeQualityCheckStatus {
  NOT_READY = 'Not Ready',
  READY = 'Ready',
}
